import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getAllPrinciple = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/projects`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
export const getPrincipleById = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/projects/projectname/${id}`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};

export const getPrincipleByPartnerId = async (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/projects/partnerId/${id}`);
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};

export const getAllPrincipleForDropDown = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.get(`/api/get-principles`);
      //
      resolve(response.data);
    } catch (error) {
      console.error("Error in getLocationByCity:", error);
      reject(error);
    }
  });
};
